<template>
  <div>
    <div class="TianCharts">
      <div id="myChart"></div>
    </div>
  </div>
</template>
<script>
import pos from "../../../assets/jpg/pos.svg";
import lypos from "../../../assets/jpg/LyPos.png";
import qs from "qs";
import { mapState } from "vuex";

export default {
  data() {
    return {
      posData: [],
      MyxAxis: [],
      lyPos: [],
      maxLy: 0,
      BrandSel: "",
      CateGory2Sel: "",
      CateGory3Sel: "",
      platFormSel: "",
      startTime: "",
      endTime: "",
    };
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          formatter: "{a0} : {c0}% </br>{a1} : {c1}%",
          height: 280,
          backgroundColor: " rgba(204, 69, 69,0.8);",
          padding: [5, 20, 10, 20], //边距
          borderColor: "#DDDDDF", //边框颜色
          borderWidth: 1, //边框线宽度
          textStyle: {
            //文字样式
            fontFamily: "PingFangSC-Regular",
            fontSize: "12px",
            color: " #FFFFFF",
          },
        },
        legend: {
          show: true,
          top: "3.5%",
          right: "3.5%",
          itemWidth: 10,
          itemHeight: 10,
          icon: "circle",
          data: [
            {
              name: "强生GMV增长率",
            },
            {
              name: "市场GMV增长率",
            },
          ],
          textStyle: {
            color: "#626262",
            fontSize: 10,
            letterSpacing: 0,
            fontFamily: "PingFangSC-Regular",
          },
        },
        grid: [
          {
            show: false,
          },
        ],
        xAxis: {
          show: true,
          type: "category",
          splitLine: { show: false },
          data: this.MyxAxis,
          axisLabel: {
            interval: 0,
            rotate: 40,
            show: true,
            textStyle: {
              fontFamily: "STYuanti-SC-Light",
              fontSize: 10,
              color: "#292929",
              letterSpacing: 0,
              textAlign: "center",
            },
          },
          axisLine: {
            lineStyle: {
              color: "white",
            },
          },
        },
        yAxis: [
          {
            show: true,
            type: "value",
            axisLabel: {
              formatter: "{value} %",
              interval: 0,
              show: true,
              textStyle: {
                color: "#626262",
                fontSize: 10,
                letterSpacing: 0,
                fontFamily: "PingFangSC-Regular",
              },
            },
          },
        ],
        series: [
          {
            name: "市场GMV增长率",
            type: "line",
            smooth: true,
            data: this.lypos,
            yAxisIndex: 0,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#5173B0", //折线颜色
              },
            },
          },
          {
            name: "强生GMV增长率",
            type: "line",
            smooth: true,
            data: this.posData,
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: "#23C8D8",
                areaStyle: { type: "default" },
                lineStyle: { color: "#23C8D8" },
              },
            },
            areaStyle: {
              // 实现蓝白渐变色
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#23C8D8",
                  },
                  {
                    offset: 1,
                    color: "#FFFFFF",
                  },
                ]),
              },
            },
          },
        ],
      });
    },
    getTianchartsList() {
      this.$addr
        .post(
          "/radar/getSumMonthCateGory3",
          qs.stringify({
            platForm: this.platFormSel,
            cateGory2: this.CateGory2Sel,
            cateGory3: this.CateGory3Sel,
            monthFrom: this.startTime,
            monthTo: this.endTime,
            brand: this.BrandSel,
          })
        )
        .then((res) => {
          this.posData = [];
          this.lypos = [];
          this.MyxAxis = [];
          this.tableList = res.data.data;
          this.tableList.map((item, index) => {
            if (item.jnj) {
              this.posData.push(parseFloat(item.growth));
            } else {
              this.lypos.push(parseFloat(item.growth));
            }
            this.MyxAxis.push(item.yyyymm);
            this.MyxAxis = [...new Set(this.MyxAxis)];
          });
          this.drawLine();
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
  },
  computed: {
    ...mapState([
      "ComMonthFrom",
      "ComMonthTo",
      "ComBrand",
      "ComCateGory2",
      "ComCateGory3",
      "PlatForm",
    ]),
  },
  watch: {
    ComCateGory3(currVal) {
      this.CateGory3Sel=currVal
      this.setOneGet();
    },
    ComMonthFrom(currVal) {
      this.startTime=currVal
      this.setOneGet();
    },
    ComMonthTo(currVal) {
      this.endTime=currVal
      this.setOneGet();
    },
    ComCateGory2(currVal) {
      this.CateGory2Sel=currVal
      this.setOneGet();
    },
    ComBrand(currVal) {
      this.BrandSel=currVal
      this.setOneGet();
    },
    PlatForm(currVal) {
      this.platFormSel=currVal
      this.setOneGet();
    },
  },
  created() {
    let _ = require("lodash");
    this.setOneGet = _.debounce(this.getTianchartsList, 500);
  },
};
</script>
<style scoped>
.TianCharts {
  position: relative;
}
#myChart {
  min-height: 280px;
  /* margin-bottom: 20px; */
  background: #faf1e7;
  box-shadow: 0 5px 20px 0 rgba(175, 151, 123, 0.5);
  border-radius: 25px;
}
#rate {
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 280px;
  margin-bottom: 20px;
}
.brandSel {
  position: relative;
}
.van-dropdown-menu {
  position: absolute;
  z-index: 7;
  top: 10px;
  left: 20px;
  background: #ffffff;
  border: 1px solid #d15757;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  border-radius: 42.5px;
  width: 36.7%;
  height: 21px;
}
/deep/ .van-popup--top {
  width: 36.7%;
  background: rgba(209, 87, 87, 0.9);
  border-radius: 5%;
  left: 30px;
  top: 2px;
}
/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-cell__value {
  display: none;
}
/deep/ .van-cell__title {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #ffffff;
}
/deep/ .van-cell {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-ellipsis {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #cc4545;
}
/deep/ .van-dropdown-menu__title::after {
  border-color: transparent transparent #cc4545 #cc4545;
}
/deep/ .van-dropdown-item__content {
  max-height: 55%;
}
</style>


// WEBPACK FOOTER //
// src/components/ButFo_Radar/public/Competitive_map.vue